

import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from '../models/user';
import {AppConstants} from '../AppConst';

@Injectable()
export class AuthentificationService {

    baseUrl: string;
  constructor(
      private http: HttpClient,
      private user: User
  ) {
      this.baseUrl = AppConstants.baseURL ;
  }

    getUsers() {
        return this.http.get<any[]>(this.baseUrl);
    }

    login(username: string, password: string) {
       this.user.login = username;
        this.user.password = password;
        const seq = this.http.post(`${this.baseUrl}login`, this.user);
        return seq;
    }

    rejetpassword(username: string, email: string) {
        this.user.login = username;
        this.user.email = email;
        const seq = this.http.post(`${this.baseUrl}rejetpassword`, this.user);
        return new Promise(resolve => {
            seq.subscribe((data: any) => {
                resolve(data);
            }, err => {
                resolve(err);
            });
        });
    }

    changepassword(id: number, oldpassword: string, newpassword: string) {

        const seq = this.http.post(`${this.baseUrl}changepassword`, {id: id, oldpassword: oldpassword, newpassword: newpassword});
        return new Promise(resolve => {
            seq.subscribe((data: any) => {
                resolve(data);
            }, err => {
                resolve(err);
            });
        });
    }

}




// WEBPACK FOOTER //
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/app/services/authentification.service.ts